import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { AutoCompleteComponent, StatesService, UIComponentState } from '@leandredev/common_ng_14';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { BehaviorSubject } from 'rxjs';
import { map, mergeMap, startWith, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
  selector: 'app-document-form-auto-complete',
  templateUrl: './Document.component.html',
  styleUrls: ['./Document.component.scss']
})
export class DocumentFormAutoCompleteComponent extends AutoCompleteComponent<interfaces.IDocument> implements OnInit, OnDestroy {
  private _selectTypesObs: BehaviorSubject<string[]> = new BehaviorSubject([]);
  private _selectTypes: string[] = ['*'];

  @Output()
  docSelected: EventEmitter<interfaces.IDocument> = new EventEmitter();

  @Input()
  public set selectTypes(types: string[]) {
    if (types && types.length >= 0) {
      this._selectTypesObs.next(types);
    }
  }

  @Input()
  public get hasOverridedData(): boolean {
    return this._hasOverridedData;
  }
  public set hasOverridedData(value: boolean) {
    this._hasOverridedData = value;
    if (!value) {
      return;
    }
    this.unsubscribePformCtrl();
    if (this.overridedData) {
      this.filteredData = this.overridedData;
    }
  }
  private _hasOverridedData = false;

  @Input()
  public get overridedData(): interfaces.IDocument[] {
    return this._overridedData;
  }
  public set overridedData(value: interfaces.IDocument[]) {
    this._overridedData = value;
    if (!value || !this.hasOverridedData) {
      return;
    }
    this.filteredData = value;
  }
  private _overridedData: interfaces.IDocument[] = [];

  constructor(uIComponentState: UIComponentState, statesService: StatesService, private router: Router, protected apiService: ApiService) {
    super(uIComponentState, statesService);
    this.httpServiceBase = apiService.collections.Document;

    if (this.hasOverridedData) {
      return;
    }
    this.pformCtrlSub = this._selectTypesObs
      .pipe(
        map((value) => {
          this._selectTypes = value;
          //return value;
        }),
        switchMap(() => {
          return this._formCtrl.valueChanges;
        }),
        startWith(null),
        mergeMap((value) => {
          if (typeof value === 'string') {
            if (value) {
              value = value.trim();
            }
            if (value) {
              return this.httpServiceBase.get(
                `type/${this._selectTypes.join('/')}/${this._selectTypes.length}/[/name/${value}/i/$regex/&/10/$limit/`
              );
            } else {
              return this.httpServiceBase.get(`type/${this._selectTypes.join('/')}/${this._selectTypes.length}/[/10/$limit/`);
            }
          } else {
            return this.httpServiceBase.get(`*/10/$limit/`);
            // return this.httpServiceBase.get(`type/${this._selectTypes.join('/')}/${this._selectTypes.length}/[/10/$limit/`);
          }
        }),
        map((result) => {
          if (!this.pformCtrlSub) {
            return;
          }
          if (this.hasOverridedData) {
            this.unsubscribePformCtrl();
            this.filteredData = this.overridedData;
            return;
          }
          this.filteredData = result.response as interfaces.IDocument[];
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    const ctrl = this.formCtrl || this.formArr;
    ctrl.valueChanges.subscribe(() => {
      if (ctrl.disabled) {
        this._formCtrl.disable();
      } else {
        this._formCtrl.enable();
      }
    });
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    super.selected(event);

    this.docSelected.emit(event.option.value);
  }

  private unsubscribePformCtrl(): void {
    if (!this.pformCtrlSub) {
      return;
    }
    this.pformCtrlSub.unsubscribe();
    // delete this.pformCtrlSub;
  }

  editClassItem(id: string): void {
    if (id != '' && id != undefined) {
      const urlforEdit = '/data/Document/edit/' + id + '/';
      void this.router.navigate([urlforEdit]);
    }
  }
}
